import { Row, Col } from 'antd';
import { FormType } from 'enums/FieldTypeEnums';
import React from 'react';
import FieldsRow from 'shared/components/FieldsRow';
import { getCoProductsData } from './stage0FarmData';
import styles from './farmCommodity.module.scss';
import { UseFieldArrayRemove } from 'react-hook-form';

export interface CoProductsComponentProps {
  remove: UseFieldArrayRemove;
  index: number;
  isDisabled?: boolean;
}

const CoProductsComponent = ({ remove, index ,isDisabled}: CoProductsComponentProps) => {
  const coProductsData = getCoProductsData({
    remove,
    index,
    isDisabled
  });
  return (
    <Row className={styles.coProductsFieldsContainer}>
      <Col span={24} className={styles.coProductsRowContainer}>
        <FieldsRow {...coProductsData} formType={FormType.REACT_HOOK_FORMS} />
      </Col>
    </Row>
  );
};

export default CoProductsComponent;
